import FormLayoutRoleAssociation, {
  FormLayoutRoleAssociationRecord,
} from "@mapmycustomers/shared/types/layout/FormLayoutRoleAssociation";

const mapAssociationToRecord = (
  entry: FormLayoutRoleAssociation
): FormLayoutRoleAssociationRecord => ({
  layout: { id: entry.layout.id },
  role: { id: entry.role.id },
  team: entry.team ? { id: entry.team.id } : null,
});

export default mapAssociationToRecord;
